// The editorial layout has a single in-content ad (the centered ad injected by
// EditorialAdsBlocksManager). Its GAM unit rotates by the article's position in the
// infinite-scroll sequence — the host is position 1, each appended article increments —
// cycling per viewport:
//   ≥1360          970x250_desktop_in_article_1 / _2            (cycle of 2)
//   ≥768           750x200_1 / _2 / _3            (728x90)      (cycle of 3)
//   <768           300x250_article_mobile_1 / _2 / _3           (cycle of 3)
// The DOM slot id is fixed (article_responsive_1); only the ad unit + size change.
// Used by both the host registration (ads-body.ts) and the appended re-registration
// (infinite-scroll/ads.ts → registerFragmentAds).

import { TABLET_MIN_WIDTH } from './breakpoints';

// The widest tier needs its own threshold, well above DESKTOP_MIN_WIDTH: the main column
// is capped at 980px and sits beside a fixed 300px aside with a 40px gutter, so a 970x250
// creative only fits once the viewport clears 970 + 300 + 40 + 2x16 padding = 1342px.
// Below that the 970x250 ad overflowed the column and overlapped the sidebar. This is not
// DESKTOP_MIN_WIDTH -- that one mirrors the SCSS $width-desktop layout switch and is
// shared with the sidebar stack, the end-of-main ad and the non-editorial templates.
const WIDE_AD_MIN_WIDTH = 1360;

// Matches the id rendered by the ads-editorial-1 block (the single centered editorial ad).
export const EDITORIAL_CONTENT_AD_ID = 'cybernews_com_article_responsive_1';

interface ContentAdUnit {
    slot: string;
    dimensions: googletag.GeneralSize;
}

/**
 * GAM unit + size for the editorial in-content ad at the given 1-based article position
 * (host = 1) and viewport width.
 */
export const editorialContentAd = (position: number, width: number): ContentAdUnit => {
    if (width >= WIDE_AD_MIN_WIDTH) {
        const n = ((position - 1) % 2) + 1; // 1, 2, 1, 2, …

        return {
            slot: `/21924397842/cybernews.com_970x250_desktop_in_article_${n}`,
            dimensions: [970, 250],
        };
    }

    if (width >= TABLET_MIN_WIDTH) {
        const n = ((position - 1) % 3) + 1; // 1, 2, 3, 1, …

        return {
            // Actual creative size is 728x90 (the 750x200_n unit serves a 728x90 leaderboard).
            slot: `/21924397842/cybernews.com_750x200_${n}`,
            dimensions: [728, 90],
        };
    }

    const n = ((position - 1) % 3) + 1; // 1, 2, 3, 1, …

    return {
        slot: `/21924397842/cybernews.com_300x250_article_mobile_${n}`,
        dimensions: [300, 250],
    };
};
